import styled from 'styled-components';
import { Tooltip } from 'antd';

export const CustomTooltip = styled(Tooltip)`
	font-size: 0.7rem;
	margin-left: 0.5rem;
`;
